export default "__VITE_ASSET__bk_D5ddF__"